import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-unlock-icon',
  templateUrl: './general-unlock.component.html'
})
export class GeneralUnlockComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
